import Validation from "../../../Validation/SubOrderPersonFormValidation";
import React, { useEffect, useState } from "react";
import InputField from "../../../FormComponents/InputField";
import { Button, CircularProgress, Grid, Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import FormAlert from "../../../components/FormAlert";
import { getSubOrderPersonById, updateSubOrderPerson } from "../../../services/SubOrderPerson";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PersonIcon from "@mui/icons-material/Person";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  margin: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)",
}));

function SubOrderPersonEdit() {
  const { personId } = useParams();
  const history = useHistory();

  const [values, setValues] = useState({
    _name: "",
    _address: "",
    _email: "",
    _phone: "",
  });

  const [error, setError] = useState({});
  const [displayAlert, setAlert] = useState(false);
  const [alertData, setAlertData] = useState({ type: "", message: "" });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadPerson();
  }, [personId]);

  const loadPerson = async () => {
    setIsLoading(true);
    const person = await getSubOrderPersonById(personId);
    if (!person || person === "Something went wrong...") {
      setAlertData({ type: "error", message: "Failed to load person data." });
      setAlert(true);
      setIsLoading(false);
      return;
    }
    setValues({
      _name: person.personName || "",
      _address: person.address || "",
      _email: person.email || "",
      _phone: person.phone || "",
    });
    setIsLoading(false);
  };

  const handleChange = (name, val) => {
    setError({ ...error, [name]: undefined });
    setValues({ ...values, [name]: val });
  };

  const submitValue = async () => {
    const validationErrors = Validation(values);
    setError(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      const result = await updateSubOrderPerson(personId, values);
      if (result) {
        setAlertData({ type: "success", message: "Sub Order Person updated successfully." });
        setAlert(true);
      } else {
        setAlertData({ type: "error", message: "Something went wrong..." });
        setAlert(true);
      }
    }
  };

  if (isLoading) {
    return (
      <StyledPaper elevation={3}>
        <CircularProgress />
      </StyledPaper>
    );
  }

  return (
    <StyledPaper elevation={3}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <PersonIcon color="primary" />
            </Grid>
            <Grid item xs>
              <Typography variant="h6">Edit Sub Order Person</Typography>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={() => history.goBack()}
                size="small"
              >
                Back
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={9}>
          <InputField
            name="_name"
            errorMsg={error._name}
            value={values._name}
            onChange={(event, newInputValue) => handleChange(event, newInputValue)}
            type="text"
            label="Person Name"
          />
        </Grid>
        <Grid item xs={12} sm={9}>
          <InputField
            name="_email"
            errorMsg={error._email}
            value={values._email}
            onChange={(event, newInputValue) => handleChange(event, newInputValue)}
            type="text"
            label="Email"
          />
        </Grid>
        <Grid item xs={12} sm={9}>
          <InputField
            name="_phone"
            errorMsg={error._phone}
            value={values._phone}
            onChange={(event, newInputValue) => handleChange(event, newInputValue)}
            type="text"
            label="Phone Number"
          />
        </Grid>
        <Grid item xs={12} sm={9}>
          <InputField
            name="_address"
            errorMsg={error._address}
            value={values._address}
            onChange={(event, newInputValue) => handleChange(event, newInputValue)}
            type="text"
            label="Address"
          />
        </Grid>

        <Grid item xs={12}>
          {displayAlert ? (
            <FormAlert type={alertData.type} message={alertData.message} />
          ) : null}
        </Grid>

        <Grid item xs={12}>
          <Grid container justifyContent="space-between">
            <Grid item xs={12} sm={4}>
              <Button fullWidth variant="contained" onClick={submitValue}>
                Save Changes
              </Button>
            </Grid>
            <Grid item xs={12} sm={1}>
              <Button onClick={() => history.goBack()} variant="outlined">
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </StyledPaper>
  );
}

export default SubOrderPersonEdit;
